<template>
    <div class="switch-cell-wrapper" :class="{ 'justify-start': value.alignLeft }">
        <switch-generic
        :disabled="disabled || (isBoolean ? null : value.disabled)"
        :isActive="isBoolean ? value : value.isActive"
        @clicked="emit('toggleSwitch', isBoolean ? value : value.isActive)"/>
    </div>
</template>

<script setup>
import SwitchGeneric from '@/components/generic/switch/Generic'
/* Vue */
import { computed } from 'vue'
/* Emmitters */
const emit = defineEmits(['toggleSwitch'])

/** Props received
@value [Boolean] can be only a boolean
or
@value { Object } - object with:
    isActive { Boolean }
    disabled { Boolean } - this disabled is specific for our switch cell,
    alignLeft { Boolean } - to align left
@disabled { Boolean } - component is disabled or not > when all row is disabled
*/
const props = defineProps({
    value: [Boolean, Object],
    disabled: Boolean
})

const isBoolean = computed(() => {
    return typeof props.value === 'boolean'
})
</script>

<style lang="scss" scoped>
.switch-cell-wrapper {
	width: auto;
    min-width: 54px;

	display: flex;
	align-items: center;
    justify-content: flex-end;

    &.justify-start {
        justify-content: flex-start;
    }
}
</style>
